import { Link } from "react-router-dom";
import { TEXT_LINK_CLASS } from "@/lib/linkStyles";
import { Images } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useGalleriesList } from "@/queries/event-gallery";

/** How many of the newest galleries the dashboard card previews. */
const DASHBOARD_GALLERY_COUNT = 3;

/**
 * Members-area dashboard widget — the newest galleries with a link to the
 * index. Visible to any signed-in user, like gallery viewing itself. Renders
 * nothing at all (no empty card) until the list resolves with at least one
 * gallery.
 */
export function GalleriesCard() {
  const { data } = useGalleriesList();
  const galleries = (data ?? []).slice(0, DASHBOARD_GALLERY_COUNT);

  if (galleries.length === 0) return null;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">Gallery</CardTitle>
        <Images className="size-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="space-y-3">
        <ul className="space-y-2">
          {galleries.map((gallery) => (
            <li key={gallery.id}>
              <Link
                to={`/gallery/${gallery.id}`}
                className="flex items-center gap-2 text-sm text-yellow-700 hover:underline dark:text-yellow-400"
              >
                <img
                  src={gallery.cover_url}
                  alt=""
                  loading="lazy"
                  className="size-8 shrink-0 rounded object-cover"
                />
                <span className="truncate font-medium">{gallery.title}</span>
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/gallery" className={`block text-sm ${TEXT_LINK_CLASS}`}>
          View the gallery
        </Link>
      </CardContent>
    </Card>
  );
}
